import styled from "styled-components"
import REFRESH_SVG from "assets/images/refresh.svg";
import { MouseEventHandler } from "react";

interface RefreshProps{
    onRefreshClick:MouseEventHandler<HTMLDivElement>
}

const Refresh = ({onRefreshClick}:RefreshProps) => {
    return(
        <Container onClick={onRefreshClick}>
            <RefreshLogo src={REFRESH_SVG} alt="refresh" />
            <Label>새로고침</Label>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    cursor: pointer;
`

const Label = styled.span`
    color: #64748B;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
`

const RefreshLogo = styled.img`
    width: 20px;
`

export default Refresh;